import { Component, OnInit } from '@angular/core';
import { GymListEntry } from '../../model/gym-list-entry';
import { GymService } from '../../services/gym.service';
import { ModalController } from '@ionic/angular';
import { shareGymLink } from '../../services/deep-links.service';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { firstValueFrom } from 'rxjs';
import { ActiveGymFacade } from 'src/store/active-gym/active-gym.facade';

@Component({
  selector: 'app-gyms',
  templateUrl: './gyms.page.html',
  styleUrls: ['./gyms.page.scss']
})
export class GymsPage implements OnInit {

  gyms: GymListEntry[];
  activeGym: GymListEntry;

  constructor(
    private socialSharing: SocialSharing,
    private activeGymFacade: ActiveGymFacade,
    private gymService: GymService) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.loadData();
  }

  private async loadData() {
    this.gyms = await firstValueFrom(this.gymService.getLocalGyms$());
    const activeGymId = await firstValueFrom(this.activeGymFacade.activeGymId$);
    this.activeGym = this.gyms.filter(g => g.gymId === activeGymId)[0];
    this.gyms = this.gyms.filter(g => g.gymId !== activeGymId);
  }

  gymPressed(gym: GymListEntry) {
    setTimeout(() => {
      const link = shareGymLink(gym.gymId);
      this.socialSharing.share(null, null, null, link);
    }, 500);
  }
}
